import { render, staticRenderFns } from "./LEDDLog.vue?vue&type=template&id=0845c89f&"
import script from "./LEDDLog.vue?vue&type=script&lang=js&"
export * from "./LEDDLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports